import { render, staticRenderFns } from "./AddPaymentCardBlock.vue?vue&type=template&id=c74b5da4&"
import script from "./AddPaymentCardBlock.vue?vue&type=script&lang=ts&"
export * from "./AddPaymentCardBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports